import { MedicSearchState } from './medic-search.state';
import { Action, ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { setMedicSearchState } from './medic-search.actions';

export const initialMedicSearchState: MedicSearchState = {
  searchResults: null,
  nameFieldContent: '',
  zipCodeFieldContent: null,
  saleOfferBegin: '',
};

export const generalMedicSearchReducers: ReducerTypes<MedicSearchState, ActionCreator[]>[] = [
  on(setMedicSearchState, (medicSearchState, payload) => {
    return {
      ...medicSearchState,
      ...payload,
    };
  }),
];

const medicSearchReducer = createReducer<MedicSearchState>(initialMedicSearchState, ...generalMedicSearchReducers);

export function reducer(state: MedicSearchState | undefined, action: Action): MedicSearchState {
  var ret = medicSearchReducer(state, action);
  return ret;
}
